import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import Honeybadger from 'honeybadger-js'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import TermsAndConditionsForm from 'pages/TermsAndConditions/TermsAndConditionsForm'

import { useSessionContext } from 'hooks/SessionContext'
import { useServerErrorContext } from 'hooks/ServerErrorContext'

import Api from 'services/api'

const TermsAndConditions = () => {
  const { session: { userName } } = useSessionContext()
  const navigate = useNavigate()
  const { setServerError } = useServerErrorContext()

  const onClickAccept = useCallback(async () => {
    await Api.Session.update({ termsUpToDate: true })
      .then(() => {
        navigate(0)
      })
      .catch(() => {
        Honeybadger.notify('Error accepting terms', { context: { username: userName } })
        setServerError('Failed to update users terms and condition status')
      })
  }, [navigate, setServerError, userName])

  return (
    <>
      <TermsAndConditionsForm />
      <S.ButtonContainer>
        <S.LogoutLink href={`${Api.Session.logout}`}>
          <Button decoration="textOnly" text="Reject" />
        </S.LogoutLink>
        <Button decoration="positive" text="Accept" onPress={onClickAccept} />
      </S.ButtonContainer>
    </>

  )
}

export default TermsAndConditions

const S = {
  ButtonContainer: styled.div`
    display: flex;
    max-width: 50em;
    margin-left: auto;
    margin-right: auto;
  `,
  LogoutLink: styled.a`
    margin-right: 15px;
  `
}
